import script from "./feedback-source.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./feedback-source.vue?vue&type=script&setup=true&lang=js"
export * from "./feedback-source.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./feedback-source.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__